import { c as _c } from "react/compiler-runtime";
import React from 'react';
import clsx from 'clsx';
import { AboutSpreadGroupTeaserItem } from '@/types/amplience';
import ModuleItem from '@/components/AboutSpreadGroupModule/ModuleItem';
import Slider from '@/components/Slider/Slider';
interface SliderVariantProps {
  items: AboutSpreadGroupTeaserItem[];
  textColorClass: string;
  isBackgroundBlack: boolean;
  setProgress: React.Dispatch<React.SetStateAction<number>>;
  isLargeScreen?: boolean;
}
const SliderVariant: React.FC<SliderVariantProps> = t0 => {
  const $ = _c(19);
  const {
    items,
    textColorClass,
    isBackgroundBlack,
    setProgress,
    isLargeScreen
  } = t0;
  const imageSizes = isLargeScreen ? "(min-width: 768px) 30vw, (min-width: 1440px) 30vw, 65vw" : "65vw";
  const t1 = isLargeScreen ? "[--slides-to-show:1.4] sm:[--slides-to-show:2.9] lg:[--slides-to-show:3]" : "[--slides-to-show:1.4]";
  const t2 = isBackgroundBlack ? "bg-white text-black" : "bg-black text-white";
  let t3;
  if ($[0] !== t2) {
    t3 = clsx("!hidden md:!flex lg:size-16", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = isBackgroundBlack ? "bg-white text-black" : "bg-black text-white";
  let t5;
  if ($[2] !== t4) {
    t5 = clsx("!hidden md:!flex lg:size-16", t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t1 || $[5] !== t3 || $[6] !== t5) {
    t6 = {
      root: t1,
      item: "mr-6 last:mr-0 md:mr-8 lg:mr-12 xl:mr-18",
      navPrev: t3,
      navNext: t5
    };
    $[4] = t1;
    $[5] = t3;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== imageSizes || $[9] !== items || $[10] !== textColorClass) {
    let t8;
    if ($[12] !== imageSizes || $[13] !== textColorClass) {
      t8 = (item, idx) => <ModuleItem imageSizes={imageSizes} key={idx} item={item} textColorClass={textColorClass} />;
      $[12] = imageSizes;
      $[13] = textColorClass;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    t7 = items.map(t8);
    $[8] = imageSizes;
    $[9] = items;
    $[10] = textColorClass;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[15] !== setProgress || $[16] !== t6 || $[17] !== t7) {
    t8 = <Slider className={t6} showNavigation={true} onProgressChange={setProgress}>{t7}</Slider>;
    $[15] = setProgress;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
export default SliderVariant;